import type {ReactNode} from 'react';

import type {ModalProps} from '.';
import Modal from '.';

interface ImageModalProps extends Pick<
  ModalProps,
  'isOpen' | 'onClose' | 'width' | 'height'
> {
  content: ReactNode;
}
const ImageModal: React.FC<React.PropsWithChildren<ImageModalProps>> = ({
  isOpen,
  onClose,
  content,
  width = 'w-350',
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width={width}
      closeOnOutsideClick
      title=""
      hideX
    >
      {content}
    </Modal>
  );
};

export default ImageModal;
